<script setup>

import checkmark from '@i/checkmark.svg';

const props = defineProps({
    label: String,
    active: Boolean,
    href: String,
});
</script>

<template>
    <button class="mb-2 flex items-center gap-3 text-base">
        <div
            class="flex h-5 w-5 items-center justify-center rounded border border-gray"
            :class="{ 'border-gray bg-gray': active }"
        >
            <img
                v-if="active"
                :src="checkmark"
                class="h-5 w-5 shrink-0 transition duration-200 ease-in-out group-hover:translate-x-1 md:h-4 md:w-4"
                alt="icon"
            >
        </div>
        <span>{{ label }}</span>
    </button>
</template>
